import React from "react";
import { Col, Button } from "antd";
import { useLeadCapture } from "../lead-capture";

const Submit = () => {
  const openLeadCapture = useLeadCapture();
  return (
    <Col
      xs={{ span: 24 }}
      lg={{
        span: 24,
        offset: 0,
      }}
      className="vc-panel vc-submit-strip"
      style={{
        padding: "24px",
      }}
    >
      <Button type="primary" onClick={() => openLeadCapture()}>
        Request Access
      </Button>
    </Col>
  );
};
export default Submit;
